import { render, staticRenderFns } from "./ColorGroupsTable.vue?vue&type=template&id=20b2f42d&"
import script from "./ColorGroupsTable.vue?vue&type=script&lang=ts&"
export * from "./ColorGroupsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports